<template>
    <div class="table-responsive">
        <vue-perfect-scrollbar style="height: 408px">
            <v-data-table
                v-if="(offline_devices || []).length > 0"
                :headers="headers"
                :items="offline_devices"
                :no-data-text="$t('lang.no_data_available')"
                hide-actions
            >
                <template slot="items" slot-scope="props">
                    <tr class="clickable" @click="$router.push({ name: 'device', params: { id: props.item.device_id } })">
                        <td class="text-center">
                            <h3>{{ props.item.public_id }}</h3>
                        </td>
                        <td>
                            <b>{{ props.item.label ? props.item.label : "---" }}</b
                            ><br /><small>{{ props.item.location_label ? props.item.location_label : "---" }}</small>
                        </td>
                        <td class="text-center">
                            <b>{{ props.item.mobile_provider }}</b>
                            <br /><small v-if="props.item.sim" style="cursor: pointer" @click.stop="$copyToClipboard(props.item.sim)">
                                <bc-tooltip>
                                    <template slot="activator">
                                        <span>{{ $textTruncate(props.item.sim, 12) }}</span>
                                        <v-icon class="fw-light ml-1" small>content_copy</v-icon>
                                    </template>
                                    Copy Sim #
                                </bc-tooltip></small
                            >
                            <small v-else>---</small>
                        </td>
                        <td class="text-center">
                            <b>{{ props.item.device_type }}</b
                            ><br /><small>{{ props.item.formatted_version }}</small>
                        </td>
                        <td class="text-center">
                            <span class="fs-12">{{ props.item.users_last_record_date ? props.item.users_last_record_date : "---" }}</span>
                        </td>
                        <td>
                            <v-icon :color="props.item.battery_class">{{ props.item.battery_icon }}</v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </vue-perfect-scrollbar>
        <app-section-loader :status="loader"></app-section-loader>
    </div>
</template>

<script>
import api from "Api";
import { mapActions, mapState } from "vuex";
import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";
export default {
    data() {
        return {
            loader: false,
            headers: [
                {
                    text: this.$t("lang.device_num"),
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                { text: this.$t("lang.company"), sortable: false, width: "25%" },
                { text: this.$t("lang.sim"), sortable: false, align: "center", width: "25%" },
                {
                    text: this.$t("lang.formatted_version"),
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("lang.last_record_date"),
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
            ],
            filter: {
                search: "",
                status: "active",
                company_id: null,
                device_type_id: null,
                tags: [],
                page_size: 20,
                page_num: 1,
                connection_status: "",
            },
        };
    },
    watch: {
        dashboard_offline_devices_page_num: {
            handler: function (val, oldVal) {
                this.refresh();
            },
            deep: true,
        },
    },
    mounted() {
        this.refresh();
    },
    computed: {
        ...mapState({
            devices: (state) => state.devices.devices,
            offline_devices: (state) => state.devices.offline_devices,
            page: (state) => state.devices.offline_devices_page,
            default_filter: (state) => state.devices.devices_filter,
            dashboard_offline_devices_page_num: (state) => state.devices.dashboard_offline_devices_page_num,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDevices"]),
        refresh() {
            this.loader = true;
            this.$store.commit("mutate", {
                property: "offline_devices",
                with: [],
            });
            this.fetchDevices({
                body: {
                    connection_status: "offline",
                    page_num: this.dashboard_offline_devices_page_num,
                    tags: this.current_user.tags_filter !== null ? [...this.current_user.tags_filter.split(",")] : [],
                },
            }).then((data) => {
                this.$store.commit("mutate", {
                    property: "offline_devices",
                    with: [...this.devices],
                });
                this.loader = false;
            });
        },
    },
    components: {
        AppSectionLoader,
    },
};
</script>
